import React from 'react';
import { grayDarkM, surfaceM } from 'web-ui-kit/colors';

function ClockIcon(_ref) {
  var _ref$className = _ref.className,
      _ref$style = _ref.style;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "7.25",
      fill: grayDarkM,
      stroke: grayDarkM,
      strokeWidth: "1.5"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 4V9H11V8.375H7.8V4H7Z",
      fill: surfaceM,
      stroke: surfaceM,
      strokeWidth: "0.5"
    }))
  );
}

export default ClockIcon;